import { createSlice } from "@reduxjs/toolkit";

const aiSearchSlice = createSlice({
  name: "aiSearch",
  initialState: {
    filters: null, // { searchText, minPrice, maxPrice, workType, types, location }
    isActive: false,
  },
  reducers: {
    applyAiFilters(state, action) {
      state.filters = action.payload;
      state.isActive = true;
    },
    clearAiFilters(state) {
      state.filters = null;
      state.isActive = false;
    },
  },
});

export const { applyAiFilters, clearAiFilters } = aiSearchSlice.actions;
export default aiSearchSlice.reducer;
